import React from 'react'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface Props {
  url: string
}

const Component: React.FC<Props> = ({ url }) => (
  <a
    style={{ fontSize: '0.7em' }}
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    onClick={e => {
      // 親要素のクリックを発動させない
      e.stopPropagation()
    }}
  >
    <FontAwesomeIcon icon={faExternalLinkAlt} />
  </a>
)

export default Component
